<div [formGroup]="form" class="table-specific-settings-wrapper">
  <div class="table-specific-settings-title">
    <y42-sub-navigation [isBig]="true" [navigationType]="navigationType"> </y42-sub-navigation>
  </div>
  <div class="table-settings-section section-halved">
    <mat-form-field appearance="outline">
      <mat-label>Object Flattening Level</mat-label>
      <input
        matInput
        formControlName="max_flatten_depth"
        type="number"
        id="input"
        step="1"
        min="0"
        autocomplete="off"
      />
    </mat-form-field>
    <div>
      This table contains at least one object. Choose the level you would like to flatten your object. By default, the
      value is <b>0</b> and your object will be imported as a text. Remember, you can use the JSON extraction node
      inside Y42 Model to extract any JSON values.<br /><br />
      If you select level <b>1</b> or above, Y42 will flatten all nested objects by the respective level. However, this
      will come at a cost that a lot of columns will be generated and the system will become slow to work with.
    </div>
  </div>
</div>
